/* eslint-disable no-restricted-syntax */
import * as React from "react";
import { Link } from "react-router-dom";

// Components
import Button from "../Button/Button";
import IconArrowDown from "../Icons/IconArrowDown";
import IconDownload from "../Icons/IconDownload";

// Types
import Topic from "../../types/Topic.interface";

// Misc.
import { useBaseState } from "../../context/Base.context";
import getCorrectPluralization from "../../lib/Pluralization.lib";
import requestAndDownloadPolicyPackage from "../../lib/PolicyBundle.lib";

interface FinishCard {
  topic: Topic;
}

const FinishCard: React.FC<FinishCard> = (props: FinishCard) => {
  const { topic } = props;
  const baseState = useBaseState();
  const [qDone, setQDone] = React.useState(0);
  const [allRequiredDone, setAllRequiredDone] = React.useState(true);
  const [qOpen, setQOpen] = React.useState(topic.questions.length);

  React.useEffect(() => {
    const { questions } = topic;

    const doneQuestions = questions.filter((question) => {
      return question._id in baseState;
    });

    const openQuestions = questions.filter((question) => {
      return !(question._id in baseState);
    });

    // Iterate open Questions and check if all Questions with Prio 1 ("Must-Haves") are completed
    openQuestions.forEach((question) => {
      if (question.priority === 1 && allRequiredDone) {
        setAllRequiredDone(false);
      }
    });

    setQDone(doneQuestions.length);
    setQOpen(openQuestions.length);
  }, [baseState, topic, setQDone, setQOpen, allRequiredDone]);

  return (
    <div>
      <div className="relative" style={{ paddingBottom: "56.25%" }}>
        <img
          src={topic.imageUrl}
          alt={topic.title}
          className="absolute h-full w-full object-cover"
        />
      </div>
      <h3 className="font-serif text-l text-dw-blue font-semibold my-2 md:text-xl">
        {topic.title}
      </h3>
      <p className="text-dw-grey-11 uppercase text-2xs mb-3 md:font-xs">
        {`${getCorrectPluralization(qDone, "done")} | ${getCorrectPluralization(
          qOpen,
          "open"
        )}`}
      </p>
      <div className="text-right">
        <Button
          buttonType="secondary"
          className="sm:mr-0 mb-2 lg:w-full"
          disabled={!allRequiredDone}
          onClick={() => requestAndDownloadPolicyPackage(topic, baseState)}
        >
          <div className="flex items-center justify-between">
            Download crisis plan
            <IconDownload />
          </div>
        </Button>
        <Link
          to={`/category/${topic._id}`}
          className="text-s text-dw-blue font-bold flex items-center justify-end"
        >
          <span>Edit crisis plan</span>
          <IconArrowDown
            color="dw-blue"
            className="transform -rotate-90 w-3 h-3"
          />
        </Link>
      </div>
    </div>
  );
};

export default FinishCard;
